module.exports = __webpack_public_path__ + "media/evolve/assets/icons/floorplans/patient-04a120a815e0d7d0bc153fde5f975a25.svg";